import { render, staticRenderFns } from "./TaxReportsModal.vue?vue&type=template&id=31226682&"
import script from "./TaxReportsModal.vue?vue&type=script&lang=js&"
export * from "./TaxReportsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports